'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  app.service('sqLite', function ($q) {

    var self = this;

    var sqlResultSet = {
      /**
       * 记录行的行ID
       * 每个SQL INSERT插入操作会自动插入一个行ID，
       * 如果插入多行，则该属性返回最后一行的行ID；
       *  如果不存在记录行则调用该属性时抛出INVALID_ACCESS_ERR异常。
       */
      rinsertId: null,
      /**
       * 返回SQL语句所改变的记录行的行数，如果没有任何改变，则该属性返回0；
       */
      rowsAffected: 0,
      /**
       * 返回一个SQLResultList 对象，表示返回的所用记录行，
       * 结果按照数据库中的序列排列，如果没有数据，则返回空对象，即SQLResultList.length属相值为0；
       */
      rows: 0
    };

    self.db = null;

    self.init = function (dbName) {
      if (window.sqlitePlugin) {
        self.db = window.sqlitePlugin.openDatabase({ name: dbName || 'app.db', location: 'default' });
      }
    };

    /**
     * 执行一段事物
     * @param {Function} callback
     * @return {Promise}
     */
    self.transaction = function (callback) {

      var deferred = $q.defer();

      if (self.db) {
        self.db.transaction(callback, function (error) {
          deferred.reject({ message: error.message });
        }, function () {
          deferred.resolve();
        });
      } else {
        deferred.resolve();
      }

      return deferred.promise;
    };

    /**
     * 执行sql命令
     * @param {String} sqlCode
     * @param {Object} data
     * @return {Promise}
     */
    self.executeSql = function (sqlCode, data) {

      var deferred = $q.defer();

      if (self.db) {
        self.db.executeSql(sqlCode, data, function (res) {
          deferred.resolve(res);
        }, function (error) {
          deferred.reject({ message: error.message });
        });
      } else {
        deferred.resolve(sqlResultSet);
      }

      return deferred.promise;
    };

    /**
     * 执行sqlBatch
     * @param {Array} sqlCodes
     * @return {Promise}
     */
    self.sqlBatch = function (sqlCodes) {

      var deferred = $q.defer();

      if (self.db) {
        self.db.sqlBatch(sqlCodes, function () {
          deferred.resolve();
        }, function (error) {
          deferred.reject({ message: error.message });
        });
      } else {
        deferred.resolve();
      }

      return deferred.promise;
    };

    /**
     * 创建一个table
     * @param {String} tableName
     * @param {Array} fields
     * @return {Promise}
     */
    self.createTable = function (tableName, fields) {
      var fieldStr = '';
      if (fields && (0, _objectType.isArray)(fields) && fields.length) {
        fieldStr = ' (' + fields.join(',') + ')';
      }
      return self.db.executeSql('CREATE TABLE IF NOT EXISTS ' + tableName + fieldStr);
    };

    /**
     * 删除指定的table
     * @param {String} tableName
     * @return {Promise}
     */
    self.removeTable = function (tableName) {
      return self.db.executeSql('DROP TABLE IF EXISTS ' + tableName);
    };

    /**
     * insert data into table
     * @param {String} tableName
     * @param {Array} fields
     * @param {Array} values
     * @return {Promise}
     */
    self.insertInto = function (tableName, fields, values) {
      var fieldStr = '',
          places = '';
      if (fields && (0, _objectType.isArray)(fields) && fields.length) {
        fieldStr = ' (' + fields.join(',') + ')';
        for (var i = 0, l = fields.length; i < l; i++) {
          if (i === 0) {
            places = '(';
          }
          places += '?';
          if (i < l - 1) {
            places += ',';
          } else {
            places += ')';
          }
        }
      }
      return self.transaction(function (tx) {
        tx.executeSql('INSERT INTO ' + tableName + fieldStr + ' VALUES' + places, values);
      });
    };
  });

  return app;
};

require('angular');

require('ionic');

var _objectType = require('../../utils/objectType');

/**
 * sqLite storage
 * https://www.npmjs.com/package/cordova-sqlite-storage
 */

;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ionic1.x-common/services/sqLite.js
// module id = 167
// module chunks = 0